<script>


export default {
    data() {
        return {
            current_password: '',
            password: '',
            password_confirmation: '',
            errors: {},
            loading: false,
        }
    },
    methods: {
        submit() {
            this.errors = {};
            this.loading = true;
            const data = {
                current_password: this.current_password,
                password: this.password,
                password_confirmation: this.password_confirmation
            };
            axios.post('/profile/update-password', data)
                .then(() => {
                    this.$toast.success(this.$t('auth.change_password.password_changed'));
                }).catch((data) => {
                this.errors = data.response?.data?.errors || {};
            }).finally(() => {
                this.loading = false;
            });
        }
    },
    mounted() {
    }
}

</script>
<template>
    <div class="edit-profile">
        <form @submit.prevent="submit">

            <b-field :label="$t('auth.fields.current_password.name')" horizontal custom-class="mb-3"
                     :type="errors.current_password ? 'is-danger' : null"
                     :message="errors.current_password ? errors.current_password[0] : null">
                <b-input
                    required
                    type="password"
                    placeholder="********"
                    v-model="current_password"
                    icon="lock"
                ></b-input>
            </b-field>

            <b-field :label="$t('auth.fields.new_password.name')" horizontal custom-class="mb-3"
                     :type="errors.password ? 'is-danger' : null"
                     :message="errors.password ? errors.password[0] : null">
                <b-input
                    required
                    type="password"
                    placeholder="********"
                    v-model="password"
                    icon="lock"
                ></b-input>
            </b-field>

            <b-field :label="$t('auth.fields.password_confirmation.name')" horizontal
                     custom-class="mb-3"
                     :type="errors.password_confirmation ? 'is-danger' : null"
                     :message="errors.password_confirmation ? errors.password_confirmation[0] : null">
                <b-input
                    required
                    type="password"
                    placeholder="********"
                    v-model="password_confirmation"
                    icon="lock"
                ></b-input>
            </b-field>


            <section>
                <b-button type="is-primary"
                          native-type="submit"
                          :loading="loading">
                    {{ $t('actions.save') }}
                </b-button>
            </section>

        </form>
    </div>

</template>
